var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMode1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "unique-id"
  }, "Dark_mode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "unique-id"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 71.188 c -14.44 0 -26.188 -11.748 -26.188 -26.188 c 0 -14.44 11.748 -26.188 26.188 -26.188 c 14.439 0 26.188 11.748 26.188 26.188 c 0 4.725 -1.272 9.355 -3.679 13.392 C 62.804 66.284 54.179 71.188 45 71.188 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 14.864 c -1.104 0 -2 -0.896 -2 -2 V 2 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 10.864 C 47 13.968 46.104 14.864 45 14.864 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -1.104 0 -2 -0.896 -2 -2 V 77.137 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 V 88 C 47 89.104 46.104 90 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.864 47 H 2 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 10.864 c 1.104 0 2 0.896 2 2 S 13.968 47 12.864 47 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88 47 H 77.137 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 H 88 c 1.104 0 2 0.896 2 2 S 89.104 47 88 47 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.724 24.276 c -0.512 0 -1.023 -0.195 -1.414 -0.586 c -0.781 -0.781 -0.781 -2.047 0 -2.828 l 7.682 -7.682 c 0.781 -0.781 2.047 -0.781 2.828 0 c 0.781 0.781 0.781 2.047 0 2.828 l -7.682 7.682 C 68.747 24.081 68.235 24.276 67.724 24.276 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.594 77.405 c -0.512 0 -1.024 -0.195 -1.414 -0.586 c -0.781 -0.781 -0.781 -2.047 0 -2.828 l 7.682 -7.682 c 0.781 -0.781 2.048 -0.781 2.828 0 c 0.781 0.781 0.781 2.047 0 2.828 l -7.682 7.682 C 15.618 77.21 15.106 77.405 14.594 77.405 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.276 24.276 c -0.512 0 -1.024 -0.195 -1.414 -0.586 l -7.682 -7.682 c -0.781 -0.781 -0.781 -2.047 0 -2.828 c 0.78 -0.781 2.048 -0.781 2.828 0 l 7.682 7.682 c 0.781 0.781 0.781 2.047 0 2.828 C 23.3 24.081 22.788 24.276 22.276 24.276 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.405 77.405 c -0.512 0 -1.023 -0.195 -1.414 -0.586 l -7.682 -7.682 c -0.781 -0.781 -0.781 -2.047 0 -2.828 s 2.047 -0.781 2.828 0 l 7.682 7.682 c 0.781 0.781 0.781 2.047 0 2.828 C 76.429 77.21 75.917 77.405 75.405 77.405 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.703 17.311 c -0.785 0 -1.53 -0.465 -1.849 -1.235 L 26.697 6.039 c -0.423 -1.021 0.062 -2.19 1.082 -2.613 c 1.022 -0.422 2.19 0.062 2.613 1.082 l 4.158 10.037 c 0.423 1.021 -0.062 2.19 -1.082 2.613 C 33.217 17.261 32.958 17.311 32.703 17.311 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.456 86.728 c -0.785 0 -1.529 -0.466 -1.849 -1.235 L 55.45 75.456 c -0.423 -1.021 0.062 -2.19 1.082 -2.613 c 1.023 -0.422 2.19 0.063 2.613 1.082 l 4.157 10.036 c 0.423 1.021 -0.062 2.19 -1.082 2.613 C 61.97 86.678 61.711 86.728 61.456 86.728 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.274 63.456 c -0.785 0 -1.53 -0.466 -1.849 -1.235 c -0.423 -1.021 0.062 -2.19 1.083 -2.613 l 10.037 -4.157 c 1.021 -0.423 2.19 0.063 2.613 1.082 c 0.423 1.021 -0.062 2.19 -1.083 2.613 L 6.038 63.303 C 5.788 63.406 5.529 63.456 5.274 63.456 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.691 34.703 c -0.785 0 -1.529 -0.465 -1.849 -1.235 c -0.423 -1.021 0.062 -2.19 1.082 -2.613 l 10.036 -4.158 c 1.021 -0.422 2.189 0.062 2.613 1.082 c 0.423 1.021 -0.062 2.19 -1.082 2.613 L 75.456 34.55 C 75.206 34.653 74.946 34.703 74.691 34.703 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.297 17.311 c -0.255 0 -0.514 -0.049 -0.765 -0.153 c -1.021 -0.422 -1.505 -1.592 -1.082 -2.613 l 4.157 -10.037 c 0.423 -1.021 1.588 -1.506 2.613 -1.083 c 1.021 0.422 1.505 1.592 1.082 2.613 l -4.157 10.037 C 58.826 16.846 58.082 17.311 57.297 17.311 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.543 86.728 c -0.255 0 -0.514 -0.05 -0.765 -0.153 c -1.021 -0.423 -1.505 -1.593 -1.082 -2.613 l 4.158 -10.036 c 0.422 -1.02 1.591 -1.504 2.613 -1.082 c 1.021 0.423 1.505 1.593 1.082 2.613 l -4.158 10.036 C 30.073 86.262 29.329 86.728 28.543 86.728 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.309 34.703 c -0.255 0 -0.514 -0.049 -0.765 -0.153 L 4.507 30.392 c -1.02 -0.423 -1.505 -1.593 -1.082 -2.613 c 0.422 -1.02 1.59 -1.506 2.613 -1.082 l 10.037 4.158 c 1.02 0.423 1.505 1.593 1.082 2.613 C 16.839 34.238 16.094 34.703 15.309 34.703 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.726 63.456 c -0.255 0 -0.514 -0.05 -0.765 -0.153 l -10.036 -4.157 c -1.021 -0.423 -1.505 -1.593 -1.082 -2.613 c 0.423 -1.02 1.589 -1.505 2.613 -1.082 l 10.036 4.157 c 1.021 0.423 1.505 1.593 1.082 2.613 C 86.255 62.99 85.511 63.456 84.726 63.456 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMode1);
export default __webpack_public_path__ + "static/media/mode-1.a560e71532ea677cd3fe1a8694e969fd.svg";
export { ForwardRef as ReactComponent };